import React from 'react';
import { Box, Typography } from '@mui/material';

const EmptyState = ({ message }) => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    minHeight={200}
    bgcolor="#f5f5f5"
    borderRadius={4}
    p={3}
  >
    <Typography variant="body1" color="textSecondary">
      {message}
    </Typography>
  </Box>
);

export default EmptyState; 